import { Box, createIcon, useSlotRecipe } from '@chakra-ui/react';

import { IconDefaultProps } from './icon.default.props';
import { IconGeneratorProps } from './icon.props';

export const NocIconGenerator = ({
    createIconProps,
    isRound = false,
    withBorder = false,
    variant = 'default',
    size = 'sm',
    duoToneColor = 'current',
    accentFillColor,
    boxProps,
    colorPalette,
    css,
    ...props
}: IconGeneratorProps): JSX.Element => {
    const recipe = useSlotRecipe({ key: 'icon' });
    const styles = recipe({ variant, size } as any);

    const GeneratedIcon = createIcon({
        ...createIconProps,
        defaultProps: {
            ...IconDefaultProps,
            ...createIconProps?.defaultProps,
        },
    });

    const icon = (
        <GeneratedIcon
            css={{
                ...styles.icon,
                '& path': {
                    vectorEffect: 'non-scaling-stroke',
                    strokeWidth: 'var(--icon-stroke, 1.75)',
                },
                '& [opacity]': {
                    // Hacky override of second color
                    opacity: 1,
                    color: duoToneColor,
                },
                '& [stroke]': {
                    stroke: 'current',
                },
                '& [fill]': {
                    fill: 'current',
                },
                '& [data-fill="true"]': {
                    fill: accentFillColor,
                },
                ...css,
            }}
            {...props}
        />
    );

    return isRound || withBorder ? (
        <Box
            {...{
                colorPalette,
                ...styles.box,
                p: withBorder ? 2 : styles.box?.p,
                border: withBorder ? '1px solid' : undefined,
                borderRadius: isRound ? styles.box?.borderRadius : undefined,
                ...boxProps,
            }}
        >
            {icon}
        </Box>
    ) : (
        icon
    );
};
